export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';

export const initialState = {
    show: false,
    text: '',
    submitLabel: '',
    cancelLabel: '',
    msgType: '',
    title: '',
    buttons: [],
    width: 'xs',
    clickedCallback: () => {},
    submitFn: () => {},
    cancelFn: () => {}
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_CONFIRM:
            return {
                show: true,
                ...action.payload
            };
        case HIDE_CONFIRM:
            return {
                ...state,
                show: false,
                clickedCallback: () => {},
                submitFn: () => {},
                cancelFn: () => {}
            };
        default:
            return initialState;
    }
};